/*
 *   File : country.js
 *   Author : https://evoqins.com
 *   Description : Country capability helpers (OCR / UAE-region) driven by country_id
 *   Version : 1.0.0
*/

// UAE-region country ids: UAE(1), Dubai/NE(6), Abu Dhabi(7)
const UAE_REGION_IDS = [1, 6, 7];

// Whether the current admin's country is OCR-enabled.
// Driven by the `ocr-enabled-countries` API (list of enabled country ids) matched
// against the admin's own country_id from the profile.
// Falls back to the legacy `country !== "Egypt"` rule if API data is unavailable.
export const _isOcrEnabled = (profile, ocr_countries) => {
    if (Array.isArray(ocr_countries) && ocr_countries.length > 0 && profile?.country_id != null) {
        return ocr_countries.includes(profile.country_id);
    }
    // Fallback (API unavailable): preserve current behaviour
    return profile?.country !== "Egypt";
};

// Whether the current admin belongs to the UAE region (UAE / Dubai / Abu Dhabi).
// Falls back to the legacy string check if country_id is unavailable.
export const _isUaeRegion = (profile) => {
    if (profile?.country_id != null) {
        return UAE_REGION_IDS.includes(profile.country_id);
    }
    return profile?.country === "UAE";
};
